import {MarkSpec, DOMOutputSpec} from "prosemirror-model"


const	emDOM: DOMOutputSpec = ["em", 0],
		strongDOM: DOMOutputSpec = ["strong", 0],
		codeDOM: DOMOutputSpec = ["code", 0],
		kbdDOM: DOMOutputSpec = ["kbd", 0],
		varDOM: DOMOutputSpec = ["var", 0],
		underlineDOM: DOMOutputSpec = ["u", 0],
		strikeDOM: DOMOutputSpec = ["s", 0],
		subscriptDOM: DOMOutputSpec = ["sub", 0],
		superscriptDOM: DOMOutputSpec = ["sup", 0],
		markDOM: DOMOutputSpec = ["mark", 0]
		;

const marks: { [key: string]: MarkSpec; } = {};

/// A link. Has `href` and `title` attributes. `title`
/// defaults to the empty string. Rendered and parsed as an `<a>`
/// element.
marks.link = {
	attrs: {
		href: {validate: "string"},
		title: {default: null, validate: "string|null"}
	},
	inclusive: false,
		parseDOM: [{
		tag: "a[href]", getAttrs(dom: HTMLElement) {
			return {href: dom.getAttribute("href"), title: dom.getAttribute("title")}
		}
	}],
	toDOM(node) {
		let {href, title} = node.attrs;
		return ["a", {href, title}, 0]
	}
};

/// An emphasis mark. Rendered as an `<em>` element. Has parse rules
/// that also match `<i>` and `font-style: italic`.
marks.em = {
	parseDOM: [
		{tag: "i"}, {tag: "em"},
		{style: "font-style=italic"},
		{style: "font-style=normal", clearMark: m => m.type.name == "em"}
	],
	toDOM() {
		return emDOM
	}
};

/// A strong mark. Rendered as `<strong>`, parse rules also match
/// `<b>` and `font-weight: bold`.
marks.strong = {
	parseDOM: [
		{tag: "strong"},
		// This works around a Google Docs misbehavior where
		// pasted content will be inexplicably wrapped in `<b>`
		// tags with a font-weight normal.
		{tag: "b", getAttrs: (node: HTMLElement) => node.style.fontWeight != "normal" && null},
		{style: "font-weight=400", clearMark: m => m.type.name == "strong"},
		{style: "font-weight", getAttrs: (value: string) => /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null},
	],
	toDOM() {
		return strongDOM
	}
};

/// Code font mark. Represented as a `<code>` element.
marks.code = {
	parseDOM: [{tag: "code"}],
	toDOM() {
		return codeDOM
	}
};

marks.keyboard = {
	parseDOM: [{tag: "kbd"}],
	toDOM() {
		return kbdDOM
	}
};

marks.variable = {
	parseDOM: [{tag: "var"}],
	toDOM() {
		return varDOM
	}
};

marks.underline = {
	parseDOM: [
		{tag: "u"},
		{style: "text-decoration=underline"}
	],
	toDOM() { return underlineDOM; }
};

marks.strike = {
	parseDOM: [
		{tag: "s"},
		{style: "text-decoration=line-through"}
	],
	toDOM() { return strikeDOM; }
};

marks.subscript = {
	parseDOM: [
		{tag: "sub"}
	],
	toDOM() { return subscriptDOM; }
};

marks.superscript = {
	parseDOM: [
		{tag: "sup"}
	],
	toDOM() { return superscriptDOM; }
};

marks.mark = {
	parseDOM: [
		{tag: "mark"}
	],
	toDOM() { return markDOM; }
};

marks.fc = {
	attrs: {
		color: { default: null },
	},
	parseDOM: [
		{
			style: "color",
			getAttrs: (value) => ({ color: value }),
		},
	],
	toDOM(mark) {
		const { color } = mark.attrs;
		return ["span", { style: `color: ${color}` }, 0];
	},
};

marks.bc = {
	attrs: {
		backgroundColor: { default: null },
	},
	parseDOM: [
		{
			style: "background-color",
			getAttrs: (value) => ({ backgroundColor: value }),
		},
	],
	toDOM(mark) {
		const { backgroundColor } = mark.attrs;
		return ["span", { style: `background-color: ${backgroundColor}` }, 0];
	},
};

export default marks;